import {Component, Input, OnInit} from '@angular/core';
import {MessageService} from 'primeng/api';
import {Platform} from '@angular/cdk/platform';
import {ActivatedRoute} from '@angular/router';
import {CommonService} from "../@shared/services/common.service";
import {DatePipe, KeyValue} from "@angular/common";

@Component({
    selector: 'shipment-tracking',
    templateUrl: './shipment-tracking.component.html',
    styleUrls: ['./shipment-tracking.component.scss']
})
export class ShipmentTrackingComponent implements OnInit {

    trackingDetails: any;
    @Input() display = false;
    @Input() bookingId: any;
    @Input() shipmentType: any;
    tracking: any;
    shipmentTrackingStatusVOList: any;
    isLoading = false;
    statuses: any;

    toggleView: boolean;

    trackingDetailsArray: any[] = [];

    constructor(private commonService: CommonService,
                private messageService: MessageService,
                public platform: Platform,
                private activatedRoute: ActivatedRoute) {
    }

    originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
        return 0;
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((x) => {
            const bookingId = x.bookingId;
            if (this.display) {
                this.getTrackingByBookingId(this.bookingId);
            } else {
                if (bookingId) {
                    // this.getTrackingByBookingIdForStandAlone(bookingId);
                    this.toggleView = true;
                } else {
                    this.toggleView = false;
                }
            }
        });


    }

    getTrackingByBookingId(bookingId) {
        this.isLoading = true;
        this.commonService.getTrackingByBookingId(bookingId)
            .subscribe(
                (x) => {
                    this.trackingDetailsArray = [];
                    x.trackingDetailsHeader = this.buildTrackingDetailsHeader(x?.shipmentTrackingVO, this.shipmentType);
                    x.shipmentTrackingStatusVOList.map((res) => {
                        if (res.enabled) {
                            this.trackingDetailsArray.push(res);
                            if (res?.status === 'Booking Created' || res?.status === 'Initiated') {
                                res.icon = 'assets/branding/shipment-tracking/booking-created.svg';
                            }
                            if (res?.status === 'Booking Confirmed' || res?.status === 'Cargo Carted') {
                                res.icon = 'assets/branding/shipment-tracking/booking-confirmed.svg';
                            }
                            if (res?.status === 'In Progress') {
                                res.icon = 'assets/branding/shipment-tracking/in-progress.svg';
                            }
                            if (res?.status === 'Customs Cleared' || res?.status === 'Custom Clearance Complete' ||
                                res?.status === 'Completed') {
                                res.icon = 'assets/branding/shipment-tracking/customs-cleared.svg';
                            }
                            if (res?.status === 'Truck Placed') {
                                res.icon = 'assets/branding/shipment-tracking/truck-dispatched.svg';

                            }
                            if (res?.status === 'Truck Dispatched') {
                                res.icon = 'assets/branding/shipment-tracking/truck-placed.svg';
                            }
                            if (res?.status === 'Cargo Stuffed') {
                                res.icon = 'assets/branding/shipment-tracking/cargo-stuffed.svg';
                            }

                            if (res?.status === 'Shipment Planned' || res?.status === 'Document Received') {
                                res.icon = 'assets/branding/shipment-tracking/shipment-planned.svg';
                            }
                            if (res?.status === 'Shipment Sailed' || res?.status === 'Shipment Departed') {
                                res.icon = 'assets/branding/shipment-tracking/sailed.svg';
                            }
                            if (res?.status === 'Shipment Arrived') {
                                res.icon = 'assets/branding/shipment-tracking/arrived.svg';
                            }
                            if (res?.status === 'Shipment Delivered' || res?.status === 'Delivered') {
                                res.icon = 'assets/branding/shipment-tracking/delivered.svg';
                            }

                            if (!res.enabled) {
                                res.statusDateTime = null;
                            }
                        }
                    });
                    this.tracking = x;
                    this.isLoading = false;
                },
                (error) => {
                    this.isLoading = false;
                    this.messageService.add({
                        summary: 'Tracking Not Found !',
                        severity: 'error',
                        detail: error?.message ? error?.message : error,
                        key: 'tracking-message',
                        sticky: false
                    });
                }
            );
    }

    buildTrackingDetailsHeader(shipmentTrackingVO: any, shipmentType: any) {
        const datePipe = new DatePipe('en-US');
        if (shipmentType === 'FCL' || shipmentType === 'LCL' ||
            shipmentType === 'Transport' || shipmentType === 'Custom Clearance' || shipmentType === 'Service Job') {
            const trackingHeaderDetails =
                {
                    'Booking Number': shipmentTrackingVO?.bookingNumber,
                    'Customer Ref No.': shipmentTrackingVO?.customerReferenceNumber,
                    Vessel: shipmentTrackingVO?.vesselName,
                    Voyage: shipmentTrackingVO?.voyage,
                    'Place of Receipt': shipmentTrackingVO?.placeOfReceipt,
                    'Port of Loading': shipmentTrackingVO?.portOfLoading,
                    'Port of Discharge': shipmentTrackingVO?.portOfDischarge,
                    'Final Place of Delivery': shipmentTrackingVO?.finalPlaceOfDelivery,
                    'Transit Duration': shipmentTrackingVO?.transitDuration ? (shipmentTrackingVO?.transitDuration + ' Days') : '-',
                    'No. of Containers': shipmentTrackingVO?.numberOfContainers,
                };
            if (shipmentType === 'LCL') {
                trackingHeaderDetails['HBL/FCR Number'] = shipmentTrackingVO?.fcrOrHblNumber;
                trackingHeaderDetails['MBL Number'] = shipmentTrackingVO?.mblNumber;
            } else {
                trackingHeaderDetails['HBL Number'] = shipmentTrackingVO?.hblNumber;
                trackingHeaderDetails['MBL Number'] = shipmentTrackingVO?.mblNumber;
            }
            return trackingHeaderDetails;
        }
        if (shipmentType === 'AIR') {
            const trackingHeaderDetails =
                {
                    'Booking Number': shipmentTrackingVO?.bookingNumber,
                    'HAWB Number': shipmentTrackingVO?.hawbNumber,
                    'MAWB Number': shipmentTrackingVO?.mawbNumber,
                    'Customer Ref No.': shipmentTrackingVO?.customerReferenceNumber,
                    'Gross Weight': shipmentTrackingVO?.grossWeight + ' ' + shipmentTrackingVO?.grossWeightUOM,
                    'Transit Duration': shipmentTrackingVO?.transitDuration ? (shipmentTrackingVO?.transitDuration + ' Days') : '',
                    'Flight No 1': shipmentTrackingVO?.flightNo1,
                    'Flight No 2': shipmentTrackingVO?.flightNo2,
                    Airline: shipmentTrackingVO?.airline,
                    'Airport of Loading': shipmentTrackingVO?.airportOfLoading,
                    'Airport of Discharge': shipmentTrackingVO?.airportOfDischarge,

                };
            return trackingHeaderDetails;
        }

    }
}
